// Default: San Lorenzo Nuovo branding
export default {
  brandId: 'default',
  name: 'San Lorenzo Nuovo',
  tagline: {
    it: "Connessione, la CHIAVE per la nostra comunità",
    en: "Connection, the KEY to our community"
  },
  logoSAK: '/logo-sak-pointer-with-text-horizontal.png',
  logo: '/logo.png',
  logoLongText: '/logo-sak-long-text.png',
  colors: {
    brightBlue: '#2B6CC2',     // used as primary
    lightBlue: '#6889BD',
    brightGreen: '#31D33A',    // used as accent
    lightGreen: '#8AE35A',
    darkGreen: '#3A6135',
    white: '#FFFFFF',
    honeydew: 'rgb(199, 250, 202)',
    primary: '#2B6CC2',        // alias of brightBlue
    accent: '#31D33A'          // alias of brightGreen
  },
  mapCenter: [11.907, 42.685] // SLN
};
